// Validation des numéros de téléphone français
export const validatePhoneNumber = (phone: string): boolean => {
  // Supprimer tous les espaces, tirets, points
  const cleaned = phone.replace(/[\s\-\.]/g, '');
  
  // Patterns acceptés :
  // - Format français : 06/07 + 8 chiffres (10 chiffres total)
  // - Format international : +33 6/7 + 8 chiffres
  const frenchPhoneRegex = /^(0[67]\d{8})$/;
  const internationalPhoneRegex = /^(\+33[67]\d{8})$/;
  
  return frenchPhoneRegex.test(cleaned) || internationalPhoneRegex.test(cleaned);
};

// Formater un numéro de téléphone pour l'affichage
export const formatPhoneNumber = (phone: string): string => {
  const cleaned = phone.replace(/[\s\-\.]/g, '');
  
  if (cleaned.startsWith('+33')) {
    // Format : +33 6 XX XX XX XX
    const number = cleaned.substring(3).substring(0, 9); // Max 9 chiffres après +33
    if (number.length === 0) return '+33';
    
    const parts = [];
    parts.push(number.substring(0, 1)); // Premier chiffre (6 ou 7)
    for (let i = 1; i < number.length; i += 2) {
      parts.push(number.substring(i, i + 2));
    }
    return '+33 ' + parts.filter(p => p).join(' ');
  } else if (cleaned.startsWith('0')) {
    // Format : 06 XX XX XX XX
    const number = cleaned.substring(0, 10); // Max 10 chiffres
    const parts = [];
    for (let i = 0; i < number.length; i += 2) {
      parts.push(number.substring(i, i + 2));
    }
    return parts.filter(p => p).join(' ');
  }
  
  return phone;
};

// Validation des emails
export const validateEmail = (email: string): boolean => {
  // Regex simple mais efficace pour les emails
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

// Messages d'erreur
export const getPhoneErrorMessage = (phone: string): string | null => {
  if (!phone.trim()) return null; // Pas d'erreur si vide (sera géré par required)
  
  const cleaned = phone.replace(/[\s\-\.]/g, '');
  
  // Vérifier si c'est un numéro français mobile
  if (!cleaned.startsWith('06') && !cleaned.startsWith('07') && !cleaned.startsWith('+336') && !cleaned.startsWith('+337')) {
    return 'Le numéro doit être un mobile français (06/07)';
  }
  
  // Vérifier la longueur
  if (cleaned.startsWith('+33') && cleaned.length !== 12) {
    return 'Format invalide (+33 6/7 XX XX XX XX)';
  } else if (cleaned.startsWith('0') && cleaned.length !== 10) {
    return 'Format invalide (06/07 XX XX XX XX)';
  }
  
  if (!validatePhoneNumber(phone)) {
    return 'Numéro de téléphone invalide';
  }
  
  return null;
};

export const getEmailErrorMessage = (email: string): string | null => {
  if (!email.trim()) return null; // Pas d'erreur si vide (sera géré par required)
  
  if (!validateEmail(email)) {
    return 'Adresse email invalide';
  }
  
  return null;
};